import { motion } from "framer-motion";
import { ArrowUpRight, Calculator } from "lucide-react";
import { BRAND } from "../../lib/landingData";
import { useLang } from "../../i18n/LanguageContext";

export const TaxBanner = () => {
  const { t } = useLang();
  const b = t.brand.taxBanner;
  return (
    <section id="tax-banner" className="relative bg-[var(--ink)] text-[var(--page)]" data-testid="tax-banner">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mx-auto max-w-[1400px] px-5 sm:px-8 py-14 sm:py-16 grid lg:grid-cols-12 gap-8 items-center"
      >
        <div className="lg:col-span-8 flex items-start gap-5">
          <span className="hidden sm:flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[var(--page)]/30">
            <Calculator className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <div>
            <span className="text-xs uppercase tracking-[0.25em] text-[var(--page)]/60 font-semibold">{b.overline}</span>
            <h2 className="mt-2 font-display font-semibold tracking-tight leading-tight text-2xl sm:text-3xl lg:text-4xl">{b.title}</h2>
            <p className="mt-3 text-sm sm:text-base leading-relaxed text-[var(--page)]/75 max-w-2xl">{b.body}</p>
          </div>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <a
            href={BRAND.taxSite}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="tax-banner-cta"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-[3px] bg-[var(--page)] text-[var(--ink)]
                       text-xs font-semibold uppercase tracking-wide transition-opacity hover:opacity-85"
          >
            {b.button} <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </motion.div>
    </section>
  );
};
